import { 
    MessageResponseDto, 
    GetProviderTypeDto, 
    CreateProviderTypeDto, 
    EditProviderTypeDto,
    UtilProviderTypeControllerGet200Response,
    UtilityProviderTypeApiFp,
    DeleteProviderTypeDto,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseProviderTypeModel = UtilProviderTypeControllerGet200Response;
export type GetProviderTypeModel = GetProviderTypeDto;
export type MutateResponseProviderTypeModel = MessageResponseDto;
export type CreateProviderTypeModel = CreateProviderTypeDto;
export type UpdateProviderTypeModel = EditProviderTypeDto;
export type DeleteProviderTypeModel = DeleteProviderTypeDto;

export const apiProviderTypeFp =  UtilityProviderTypeApiFp(apiConfig);
export const getProviderTypeController = apiProviderTypeFp.utilProviderTypeControllerGet;
export const createProviderTypeController = apiProviderTypeFp.utilProviderTypeControllerCreate;
export const updateProviderTypeController = apiProviderTypeFp.utilProviderTypeControllerEdit;
export const deleteProviderTypeController = apiProviderTypeFp.utilProviderTypeControllerDelete;

export const QueryKeyProviderType = QueryKey.ProviderType;